import { useState } from "react";
import SolidityScanLogo from "../../assets/SolidityScanLogo.png";
import dashboardStyles from "../../assets/stylesheets/Dashboard.module.css";
import styles from "../../assets/stylesheets/SolidityScan.module.scss";
import { toast } from "react-hot-toast";
import { postSolidityScan } from "../../utils/api/endpoints/business/solidityScan";
import SolidityScanForm from "../../components/solidity_scan/SolidityScanForm";
import SolidityScanResult, {
  ScanResult
} from "../../components/solidity_scan/SolidityScanResult";
import usePageTitle from "../../utils/hooks/usePageTitle";

enum PageState {
  FORM,
  RESULT
}

export const platforms = [
  "Ethereum",
  "Binance",
  "Polygon",
  "Fantom",
  "Cronos",
  "Avalanche",
  "Celo",
  "Aurora"
];

export const SOLIDITY_SCAN_PLATFORMS_MAPPING = [
  {
    platform: "etherscan",
    label: "Ethereum - (etherscan.io)",
    contract_chains: [
      {
        label: "Ethereum Mainnet",
        value: "mainnet"
      },
      {
        label: "Ropsten Testnet",
        value: "ropsten"
      },
      {
        label: "Kovan Testnet",
        value: "kovan"
      },
      {
        label: "Rinkeby Testnet",
        value: "rinkeby"
      },
      {
        label: "Goerli Testnet",
        value: "goerli"
      }
    ]
  },
  {
    platform: "bscscan",
    label: "Binance - (bscscan.com)",
    contract_chains: [
      {
        label: "Bsc Mainnet",
        value: "mainnet"
      },
      {
        label: "Bsc Testnet",
        value: "testnet"
      }
    ]
  },
  {
    platform: "polygonscan",
    label: "Polygon - (polygonscan.com)",
    contract_chains: [
      {
        label: "Polygon Mainnet",
        value: "mainnet"
      },
      {
        label: "Polygon Testnet",
        value: "testnet"
      }
    ]
  },
  {
    platform: "fantom",
    label: "Fantom - (ftmscan.com)",
    contract_chains: [
      {
        label: "FTM Mainnet",
        value: "mainnet"
      },
      {
        label: "FTM Testnet",
        value: "testnet"
      }
    ]
  },
  {
    platform: "cronos",
    label: "Cronos - (cronoscan.com)",
    contract_chains: [
      {
        label: "Cronos Mainnet",
        value: "mainnet"
      },
      {
        label: "Cronos Testnet",
        value: "testnet"
      }
    ]
  },
  {
    platform: "avalanche",
    label: "Avalanche C-Chain (snowtrace.io)",
    contract_chains: [
      {
        label: "Avalanche Mainnet",
        value: "mainnet"
      },
      {
        label: "Avalanche Fuji Testnet",
        value: "testnet"
      }
    ]
  },
  {
    platform: "celo",
    label: "Celo - (celoscan.io)",
    contract_chains: [
      {
        label: "Celo Mainnet",
        value: "mainnet"
      },
      {
        label: "Alfajores Testnet",
        value: "testnet"
      }
    ]
  },
  {
    platform: "aurora",
    label: "Aurora - (aurorascan.dev)",
    contract_chains: [
      {
        label: "Aurora Mainnet",
        value: "mainnet"
      },
      {
        label: "Aurora Testnet",
        value: "testnet"
      }
    ]
  }
];

const SolidityScan = () => {
  const [pageState, setPageState] = useState(PageState.FORM);
  const [scanResult, setScanResult] = useState<ScanResult | undefined>();

  usePageTitle("Solidity Scan");

  const [platform, setPlatform] = useState(platforms[0]);
  const [chain, setChain] = useState(
    SOLIDITY_SCAN_PLATFORMS_MAPPING[0].contract_chains[0].value
  );
  const [contractAddress, setContactAddress] = useState("");

  const scanReport = async () => {
    if (!contractAddress) {
      toast.error("Please enter contract address");
      return false;
    }

    const result = await postSolidityScan({
      contract_address: contractAddress,
      contract_platform:
        SOLIDITY_SCAN_PLATFORMS_MAPPING[platforms.indexOf(platform) ?? 0]
          .platform,
      contract_chain: chain
    });
    setScanResult(result);
    setPageState(PageState.RESULT);
  };

  return (
    <>
      <img
        src={SolidityScanLogo}
        alt="Solidity Scan"
        className={styles.SSLogo}
      />
      <hr className={dashboardStyles.line} />

      {pageState === PageState.FORM ? (
        <SolidityScanForm
          platform={platform}
          contactAddress={contractAddress}
          chain={chain}
          setPlatform={setPlatform}
          setContactAddress={setContactAddress}
          setChain={setChain}
          scanReport={scanReport}
        />
      ) : (
        <>
          {scanResult !== undefined && (
            <SolidityScanResult scanResult={scanResult} />
          )}
        </>
      )}
    </>
  );
};

export default SolidityScan;
